<template>
  <v-container>

    <v-row>
      <v-col md="12">
        <h1 class="font-weight-medium">{{ $t(itemById) }} </h1>
        <v-btn v-if="isAdmin" to="/memorias/add" large color="primary" dark>
          {{ $t('Añadir') }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row>

      <v-col md="2">

        <v-menu
            v-model="fromDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
                :label="$t('Fecha (Desde)')"
                readonly
                :value="fromDateDisp"
                v-on="on"
                filled
                clearable
                @click:clear="fromDateVal=''"
            ></v-text-field>
          </template>
          <v-date-picker
              locale="ca-in"
              v-model="fromDateVal"
              no-title
              @input="fromDateMenu = false"
          ></v-date-picker>
        </v-menu>


      </v-col>
      <v-col md="2">
        <v-menu
            v-model="untilDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
                :label="$t('Fecha (Hasta)')"
                readonly
                :value="untilDateDisp"
                v-on="on"
                filled
                clearable
                @click:clear="untilDateVal=''"

            ></v-text-field>
          </template>
          <v-date-picker
              locale="en-in"
              v-model="untilDateVal"
              no-title
              @input="untilDateMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col md="2">
        <v-text-field
            :label="$t('Nombre')"
            filled
            v-model="text"
            maxlength="250"
        ></v-text-field>
      </v-col>
      <v-col md="2" style="padding-top:20px">
        <v-btn @click="search()" large color="primary" dark>
          {{ $t('buscar') }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-simple-table>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">{{ $t('Nombre') }}</th>
              <th class="text-left">{{ $t('Nombre del archivo') }}</th>
              <th class="text-left">{{ $t('Fecha') }}</th>
              <th class="text-left"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in data" :key="item.name">
              <td>{{ item.nombre }}</td>
              <td>{{ item.file.nombre }}</td>
              <td>{{ df(item.created) }}</td>
              <td>
                <v-btn color="primary" dark small :href="$store.state.baseurl+'/api/downloads/'+ item.file.id">
                  {{ $t('Descargar') }}
                </v-btn>
              </td>
              <td>
                <router-link v-if="isAdmin" :to="{ name: 'memoriasformupdate', params: { id: item.id }}">
                  {{ $t('Editar') }}
                </router-link>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>


    <v-row>

      <v-pagination
          v-model="page"
          :length="length"
          :page="page"
          total-visible="5"
      ></v-pagination>
    </v-row>


  </v-container>
</template>


<script>

import axios from "axios"
import {mapGetters} from "vuex";
import 'url-search-params-polyfill';



export default {
  data() {
    return {
      page: 1,
      fromDateMenu: false,
      fromDateVal: null,
      untilDateMenu: false,
      untilDateVal: null,
      text: "",
      length: 1,
      data: [],

    };
  },
  computed: {
    ...mapGetters([
      "isAdmin", "isLoggedIn"
    ]),
    fromDateDisp() {
      return this.fromDateVal;
      // format date, apply validations, etc. Example below.
      // return this.fromDateVal ? this.formatDate(this.fromDateVal) : "";
    },
    untilDateDisp() {
      return this.untilDateVal;
    },
    itemById(){
      const x = this.$store.state.fileItems.find(o => o.id == this.$route.params.id)
      return x.title
    }
  },
  methods: {
    df(d) {
      let current_datetime = new Date(d)
      return current_datetime.getFullYear() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getDate()
    },
    search() {
      let data = {};
      if (this.fromDateVal) {
        data.created__gte = this.fromDateVal + " 00:00:00"
      }
      if (this.untilDateVal) {
        data.created__lte = this.untilDateVal + " 23:59:59"
      }
      if (this.text) {
        data.nombre__unaccent__icontains = this.text
      }

      data.page = this.page
      data.tipo = this.$route.params.id

      const searchParams = new URLSearchParams(data);
      const jwt = this.$store.state.jwt

      const config = {
        headers: {Authorization: "Bearer " + jwt},
        params: searchParams
      };

      return axios.get(this.$store.state.endpoints.memoria, config)
          .then((response) => {
            this.data = response.data.results
            this.length = Math.ceil(response.data.count / 10)
          })
          .catch((error) => {
            console.error(error)
          })
    },
  },
  watch: {
    '$route.params.search': {
        handler: function(search) {
           this.search()
        },
        deep: true,
        immediate: true
      },
    page: function () {
      this.search()
    }
  }
};
</script>





